/* MolCellQuest — 全問題の結合
   カテゴリごとの1ファイルを import してひとつの配列にする。
   問題を追加するときは各ファイルの配列に追記するだけでよい。 */

import { GENOME_DNA } from "./genome-dna.js";
import { GENOME_EXPRESSION } from "./genome-expression.js";
import { GENOME_REGULATION } from "./genome-regulation.js";
import { CELL_ORGANELLE } from "./cell-organelle.js";
import { CELL_DYNAMICS } from "./cell-dynamics.js";
import { CELL_CYCLE } from "./cell-cycle.js";
import { CELL_IMMUNITY } from "./cell-immunity.js";
import { MOLECULE_PROTEIN } from "./molecule-protein.js";
import { MOLECULE_METABOLISM } from "./molecule-metabolism.js";
import { MOLECULE_SIGNALING } from "./molecule-signaling.js";
import { APPLIED_TECHNIQUE } from "./applied-technique.js";
import { APPLIED_MEDICINE } from "./applied-medicine.js";

export const CURRICULUM = [
  ...GENOME_DNA,
  ...GENOME_EXPRESSION,
  ...GENOME_REGULATION,
  ...CELL_ORGANELLE,
  ...CELL_DYNAMICS,
  ...CELL_CYCLE,
  ...CELL_IMMUNITY,
  ...MOLECULE_PROTEIN,
  ...MOLECULE_METABOLISM,
  ...MOLECULE_SIGNALING,
  ...APPLIED_TECHNIQUE,
  ...APPLIED_MEDICINE,
];

/** id → 問題 */
export const PROBLEM_BY_ID = Object.fromEntries(CURRICULUM.map((p) => [p.id, p]));

export function problemById(id) {
  return PROBLEM_BY_ID[id] || null;
}
